export class JobTitleCreateParams {
  accountId: string;
  title: string;

  constructor(accountId: string, title: string) {
    this.accountId = accountId;
    this.title = title;
  }
}

export interface JobTitleUpdateParams {
  title: string;
}

export interface JobTitleSearchParams {
  query: string;
  limit?: number;
  page?: number;
}
